const React = require("react");
const T = React.PropTypes;

const GlobalConstants = require("../GlobalConstants.js");
const File = require("../types/File.js");
const FileType = require("../types/FileType.js");
const HistoricalFile = require("../types/HistoricalFile.js");

const TitleBar = require("./TitleBar.jsx");
const History = require("./History.jsx");
const FileTypeSelector = require("./FileTypeSelector.jsx");
const SubmitFiles = require("./SubmitFiles.jsx");
const Spinner = require("./Spinner.jsx");

const titleHeight = 60;
const titleTopPadding = 0;
const titleHeightTotal = titleHeight + titleTopPadding;

const backgroundColor = "#eee";

const mainSectionStyle = {
    position: "fixed",
    overflow: "auto",
    left: 0,
    right: 0,
    top: titleHeightTotal,
    bottom: 0,
    backgroundColor: backgroundColor
};

const styles = {
    Main: {
        backgroundColor: backgroundColor
    },
    Title: {
        zIndex: 10,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        margin: 0,
        padding: 0,
        paddingLeft: 10,
        paddingTop: 10,
        height: titleHeight
    },
    Submit: mainSectionStyle,
    Selector: mainSectionStyle,
    History: mainSectionStyle,
    BigMessage: {
        padding: 30,
        paddingTop: titleHeightTotal
    }
};

const Main = React.createClass({
    propTypes: {
        Mode: T.string.isRequired,
        SelectedFileType: FileType.Type,
        FileTypes: T.shape({
            AreLoading: T.bool,
            Data: T.arrayOf(FileType.Type),
            LoadError: T.object
        }),
        ValidExtensions: T.shape({
            AreLoading: T.bool,
            Data: T.arrayOf(T.string),
            LoadError: T.object
        }),
        SelectedFiles: T.arrayOf(File.Type),
        History: T.shape({
            HasLoaded: T.bool.isRequired,
            IsLoading: T.bool.isRequired,
            Data: T.arrayOf(HistoricalFile.Type),
            Error: T.object
        }),
        AncientHistory: T.shape({
            HasLoaded: T.bool.isRequired,
            IsLoading: T.bool.isRequired,
            Data: T.arrayOf(HistoricalFile.Type),
            Error: T.object
        })
    },  
    render() {
        const titleBar = this.GetTitleBar();
        const body = this.GetBody();

        const UploadingMark = require("./UploadingMark.jsx");
        
        return (<main style={styles.Main}>
            {titleBar}
            {body}
        </main>);
    },
    GetTitleBar() {
        return (<TitleBar style={styles.Title} Mode={this.props.Mode} />);
    },
    GetBody() {
        if (this.props.Mode === GlobalConstants.Modes.History) {
            return (<History style={styles.History}
                             History={this.props.History}
                             AncientHistory={this.props.AncientHistory} />);
        }

        if (this.props.SelectedFileType !== null) {
            return (<SubmitFiles style={styles.Submit} 
                                 DisplayOffsetTop={titleHeightTotal}
                                 SelectedFileType={this.props.SelectedFileType}
                                 SelectedFiles={this.props.SelectedFiles}
                                 ValidExtensions={this.props.ValidExtensions}
                                 Upload={this.props.Upload}
                                 Metadata={this.props.Metadata} />);
        }

        return (<FileTypeSelector style={styles.Selector} 
                                  FileTypes={this.props.FileTypes }
                                  ValidExtensions={this.props.ValidExtensions} />);
    }
});

module.exports = Main;


// WEBPACK FOOTER //
// ./src/components/Main.jsx